(() => {
  function setupCharts() {
    document.querySelectorAll('.podhub-size-chart').forEach((chart) => {
      let unit = 'in';
      const render = () => {
        chart.querySelectorAll('[data-size-chart-value]').forEach((value) => {
          const inches = Number(value.dataset.sizeChartValue);
          value.textContent = unit === 'cm' ? (Math.round(inches * 2.54 * 10) / 10).toFixed(1) : inches;
        });
        chart.querySelector('[data-size-chart-heading="width"]').textContent = `Width, ${unit}`;
        chart.querySelector('[data-size-chart-heading="length"]').textContent = `Length, ${unit}`;
        chart.querySelectorAll('[data-size-chart-unit]').forEach((button) => {
          const active = button.dataset.sizeChartUnit === unit;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };
      chart.querySelectorAll('[data-size-chart-unit]').forEach((button) => button.addEventListener('click', () => {
        unit = button.dataset.sizeChartUnit;
        render();
      }));
    });
  }
  document.addEventListener('DOMContentLoaded', setupCharts);

  // Variant updates replace the Size Chart trigger inside the option fieldset.
  // Delegate the open action so newly rendered triggers continue to work.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.open-size-chart[aria-controls]');
    if (!trigger) return;

    const modal = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!modal || typeof modal.show !== 'function' || modal.open) return;

    event.preventDefault();
    modal.show(trigger);
  });
})();
